import { formatTime } from 'src/utils/formatTime.ts';
import { storage } from 'src/utils/storage';

type FormattedDateTime = {
    formattedTime: string;
    formattedDate: string;
};

export const getFormattedDateTime = (dateString: string | undefined): FormattedDateTime => {
    const defaultValues = { formattedTime: '', formattedDate: '' };
    if (dateString == null) return defaultValues;
    const locale = storage.getLanguage();

    const normalizedDate = dateString.includes('T')
        ? dateString.replace('Z', '') // ISO string treated as local
        : dateString.replace(' ', 'T') + ':00';

    const datetime = new Date(normalizedDate);
    const formattedDate = datetime
        ? new Date(datetime.toString()).toLocaleDateString(locale, {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
          })
        : '';
    const formattedTime = datetime ? formatTime(datetime) : '';

    if (formattedTime === 'Invalid Date' || formattedDate === 'Invalid Date') return defaultValues;

    return {
        formattedTime,
        formattedDate,
    };
};

// Function for getting the formatted datetime used in details panels
export const getFormattedDateTimeForDetailPanel = (dateString: string | undefined): string => {
    const { formattedTime, formattedDate } = getFormattedDateTime(dateString);
    return formattedTime && formattedDate ? `${formattedDate} ${formattedTime}` : '';
};
